




































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
//import Util from "../../../lib/util";
import util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Common from "../../../store/entities/common";
@Component
export default class ChangePassWords extends AbpBase {
  common: Common = new Common();
  save() {
    (this.$refs.commonForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store.dispatch({
          type: "common/changpassword",
          data: this.common,
        });
        (this.$refs.commonForm as any).resetFields();
        //this.$emit("save-success");
        //this.$emit("input", false);
        var that=this;
        this.$Modal.success({
          title: "提醒",
          content: "密码修改成功，请重新登录！",
          closable: false,
          onOk() {
            that.$store.commit("app/logout", this);
            util.abp.auth.clearToken();
            location.reload();
          },
        });
      }
    });
  }
  validatePassCheck = (rule: any, value: any, callback: any) => {
    if (!value) {
      callback(new Error("请填写确认密码"));
    } else if (value !== this.common.NewPassword) {
      callback(new Error("两次输入的密码不相同"));
    } else {
      callback();
    }
  };
  commonRule = {
    NewPassword: [
      {
        required: true,
        message: "请输入新密码",
        trigger: "blur",
      },
      {
        pattern:/(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,16}$/,
        message:"密码强度不足!必须由大写字母、小写字母和数字或特殊字符三种及以上组合!（长度8位以上）",
        trigger:"blur",
      }
    ],
    CurrentPassword: [
      {
        required: true,
        message: "请输入原始密码",
        trigger: "blur",
      },
    ],
    confirmPassword: [
      {
      required: true,
      validator: this.validatePassCheck,
      trigger: "blur",
      },
      {
        pattern:/(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,16}$/,
        message:"密码强度不足!必须由大写字母、小写字母和数字或特殊字符三种及以上组合!（长度8位以上）",
        trigger:"blur",
      }
    ]
  };
}
